import {IQuestionBase} from '../elements/base/questionElementBase';
import {IRetryQuestion} from '../elements/base/retryQuestion';

export const getAttemptsAndRetriable = (
    element: IQuestionBase,
    meta?: {retryQuestion?: {isEnabled?: boolean; attempts?: number}; retryQuestionSettings?: IRetryQuestion}
): {maxAttempts: number; retriable: boolean} | null => {
    const defaultAttempts = 2;
    const retryQuestion = meta?.retryQuestion;
    const retryQuestionSettings = meta?.retryQuestionSettings;

    if (element.retryQuestion !== undefined) {
        return {
            maxAttempts: element.noOfAttempts || defaultAttempts,
            retriable: element.retryQuestion,
        };
    }

    if (retryQuestionSettings?.retryQuestion) {
        return {
            maxAttempts: retryQuestionSettings.noOfAttempts || defaultAttempts,
            retriable: retryQuestionSettings.retryQuestion,
        };
    }

    if (retryQuestion?.isEnabled) {
        return {
            maxAttempts: retryQuestion.attempts || defaultAttempts,
            retriable: retryQuestion.isEnabled,
        };
    }

    return null;
};
